import {
  useEffect,
  useContext,
  useState
} from 'react'

import { AppContext } from '../components/AppContext.tsx'
import PageLayout from '../components/PageLayout.jsx'
import UsageSummary from '../components/usage/UsageSummary.jsx'
import MonthSelector from '../components/usage/MonthSelector.jsx'
import Spinner from '../components/Spinner.jsx'

const UsagePage = () => {
  const {
    authSession,
    generateMonthlyReport,
    models,
    initializingUI,
  } = useContext(AppContext)
  
  const currentDate = new Date()
  const [selectedMonth, setSelectedMonth] = useState(currentDate.getMonth() + 1)
  const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear())
  const [usageData, setUsageData] = useState({})
  const [loading, setLoading] = useState(false)
  
  // const testMode = import.meta.env.VITE_ENABLE_TEST_DATA === 'true'
  const testMode = false 

  useEffect(() => {
    if (initializingUI) {
      if (!loading) {
        setLoading(true)
      }
      return;
    }
    
    const fetchUsageData = async () => {
      if (!loading) {
        setLoading(true)
      }

      const data = await generateMonthlyReport(testMode, selectedMonth, selectedYear)
      if (data) {
        setUsageData(data)
        setLoading(false)
      }
    }
    
    fetchUsageData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authSession?.access_token, models, testMode, initializingUI, selectedMonth, selectedYear])
  
  const handleMonthChange = (month, year) => {
    setSelectedMonth(month)
    setSelectedYear(year)
    setLoading(true)
  }
  
  const MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ]
  
  const selectedMonthName = MONTHS[selectedMonth - 1]
  
  const isInitialLoading = initializingUI || !models || models.length === 0
  
  return (
    <PageLayout 
      title="Usage Statistics"
      description="Track your token usage and spending across different AI models."
      rightElement={
        <MonthSelector
          selectedMonth={selectedMonth}
          selectedYear={selectedYear}
          onMonthChange={handleMonthChange}
        />
      }
    >
      {testMode && (
        <div className="mb-spacing-4 p-spacing-3 bg-bg-card border border-border-default rounded-lg text-dls-small text-secondary">
          📊 Using test data. Set VITE_ENABLE_TEST_DATA=false to see real data.
        </div>
      )}
      
      {loading || isInitialLoading ? (
        <div className="flex flex-col items-center gap-spacing-4 mt-[128px]">
          <Spinner size="lg" color="text-accent" variant="ring" />
          <p className="text-secondary text-dls-body">
            {isInitialLoading ? 'Generating usage report' : 'Loading usage data...'}
          </p>
        </div>
      ) : (
        <UsageSummary usageData={usageData} selectedMonth={selectedMonthName} selectedYear={selectedYear} />
      )}
    </PageLayout>
  )
}

export default UsagePage
